module.exports = __webpack_public_path__ + "img/stores_personal_consultation@1x@2x.b75fa4f.webp";